function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.39,25.673H3.426V20.91A5.062,5.062,0,0,1,2,19.89v5.783A1.426,1.426,0,0,0,3.426,27.1H23.39a1.426,1.426,0,0,0,1.426-1.426V19.89A4.806,4.806,0,0,1,23.39,20.9Z",
  transform: "translate(0 -5.134)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.843,20.546a.713.713,0,0,0,.713-.713V15.94H21.13v1.469H14v1.426h7.13v1A.713.713,0,0,0,21.843,20.546Z",
  transform: "translate(-3.444 -4.001)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.1,4.852H17.686V3.7A1.725,1.725,0,0,0,15.939,2H10.877A1.725,1.725,0,0,0,9.13,3.7V4.852H2.713A.713.713,0,0,0,2,5.565v5.7a3.565,3.565,0,0,0,3.565,3.565H7.7v1a.713.713,0,0,0,1.426,0V11.939H7.7v1.469H5.565a2.139,2.139,0,0,1-2.139-2.139V6.278H23.39v4.991a2.139,2.139,0,0,1-2.139,2.139h-.713v1.426h.713a3.565,3.565,0,0,0,3.565-3.565v-5.7A.713.713,0,0,0,24.1,4.852Zm-7.843,0h-5.7V3.733a.321.321,0,0,1,.321-.307h5.07a.307.307,0,0,1,.314.3Z",
  transform: "translate(0 0)",
  fill: "#d6d6d6"
}));

var SvgBriefcaseLine = function SvgBriefcaseLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.816,
    height: 19.964,
    viewBox: "0 0 22.816 19.964",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBriefcaseLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/briefcase-line.13980cb8.svg";
export { ForwardRef as ReactComponent };